export default __webpack_public_path__ + "static/media/922.902675cf.png";